/** Copied from web/src/core/utils/text.ts */

/**
 * Returns the string pluralized with the count prefixed
 */
export const pluralize = (count: number, noun: string, suffix = 's', separator = ' '): string =>
  `${count}${separator}${noun}${count !== 1 ? suffix : ''}`;

const MAX_DISPLAYED_COUNT = 99;

export const formatCappedCount = (count: number): string =>
  count > MAX_DISPLAYED_COUNT ? `${MAX_DISPLAYED_COUNT}+` : `${count}`;
